module.exports = __webpack_public_path__ + "img/menu_concept.80612561.png";